// extracted by mini-css-extract-plugin
export var card = "_83-1";
export var container = "_83-0";